import { registerLocaleData } from "@angular/common";
import { provideHttpClient, withInterceptorsFromDi } from "@angular/common/http";
import { APP_INITIALIZER, ApplicationConfig, ErrorHandler, importProvidersFrom, LOCALE_ID, provideExperimentalZonelessChangeDetection } from "@angular/core";
import { provideAnimations } from "@angular/platform-browser/animations";
import { TranslateLoader, TranslateModule } from "@ngx-translate/core";
import * as Sentry from "@sentry/angular";

import localeDe from '@angular/common/locales/de';
import localeDeCH from '@angular/common/locales/de-CH';

import { de_CH } from '@assets/i18n/de_CH';
import { en_US } from '@assets/i18n/en_US';
import { Observable, of } from "rxjs";

// required for currency and date pipe
registerLocaleData(localeDe, 'de');
registerLocaleData(localeDeCH, 'ch');

export class CustomTranslateLoader implements TranslateLoader {
  getTranslation(lang: string): Observable<any> {
    switch (lang) {
      case 'de_CH': return of(de_CH);
      case 'en_US': return of(en_US);
      default: return of(de_CH);
    }
  }
}

export const appConfig: ApplicationConfig = {
  providers: [
    importProvidersFrom(
      TranslateModule.forRoot({
        loader: {
          provide: TranslateLoader,
          useClass: CustomTranslateLoader,
        },
      }),
    ),
    provideAnimations(),
    provideExperimentalZonelessChangeDetection(),
    provideHttpClient(withInterceptorsFromDi()),
    { provide: LOCALE_ID, useValue: 'de-ch' },
    { provide: ErrorHandler, useValue: Sentry.createErrorHandler({ showDialog: false, }) },
    { provide: APP_INITIALIZER, useFactory: () => () => { }, deps: [Sentry.TraceService], multi: true },
  ],
}